// trigger
import appEnv from 'bundles/directory-graphql/appEnv';
import appStarterFactory from 'bundles/page/lib/appStarterFactory';

export default appStarterFactory(appEnv);
